import { ErrorsMessage } from '../models/errors-message.interface';

// сообщения об ошибках при валидации
export const VALIDATION_ERRORS_MESSAGE: ErrorsMessage = {
  REQUIRED: 'Поле обязательно для заполнения',
  LANGUAGE: 'Поле может содержать русские буквы и тире',
  LANGUAGE_PLURAL: 'Поле может содержать русские буквы и тире',

  FIRST_NAME_REQUIRED: 'Укажите имя',
  FIRST_NAME_FORMAT: 'Поле может содержать русские буквы и тире',
  FIRST_NAME_LENGTH: 'Имя не может быть длиннее 30 символов',
  LAST_NAME_FORMAT: 'Поле может содержать русские буквы и тире',
  LAST_NAME_LENGTH: 'Фамилия не может быть длиннее 30 символов',
  MIDDLE_NAME_LENGTH: 'Отчество не может быть длиннее 30 символов',
  MIDDLE_NAME_FORMAT: 'Поле может содержать русские буквы и тире',
  LAST_NAME_REQUIRED: 'Укажите фамилию',
  FULL_NAME_REQUIRED:
    'Напишите свои Фамилию Имя и Отчество через пробел. Например: Иванов Иван Иванович',
  GENDER_REQUIRED: 'Укажите свой пол',
  BIRTHDAY_REQUIRED: 'Укажите дату вашего рождения',
  BIRTHDAY_MAX: 'Дата не может быть раньше 1917',
  BIRTHDAY_MIN: 'Чтобы воспользоваться сервисом, вы должны быть старше 18 лет',
  REASON_REQUIRED: 'Пожалуйста, укажите подходящий вам вариант',
  MAIN_PHONE_REQUIRED: 'Номер телефона необходим для связи с вами',
  PHONE_LENGTH: 'Номер телефона должен состоять из 10 цифр',
  NON_EXISTENT_PHONE:
    'Несуществующий мобильный оператор. После семёрки должна идти цифра "9"',
  EMAIL_REQUIRED:
    'E-mail необходимо указать. По этому адресу мы будем отправлять вам важные уведомления и документы по запросу',
  EMAIL_PATTERN: 'Проверьте формат. Пример: example@domain.ru',
  EMAIL_SPACE: 'Адрес электронной почты не может содержать пробелы',
  INFO_COMPLAINT_REQUIRED:
    'Обязательно для заполнения',
  ADDITIONAL_PHONE_LENGTH: 'Номер телефона должен состоять из 10 цифр',
  EMPTY_ADDITIONAL_PHONE_OWNER: 'Укажите владельца номера',
  EMPTY_ADDITIONAL_PHONE: 'Укажите номер телефона',
  MONTHLY_EXPENSE: 'Укажите сумму расходов в месяц',
  MAIN_MONTHLY_INCOME: 'Укажите сумму и источник дохода',
  COINCIDENCE_OF_NUMBERS:
    'Номер дополнительного телефона не должен совпадать с основным',
  PASSPORT_REQUIRED: 'Укажите серию и номер паспорта',
  SERIES_PASSPORT_REQUIRED: 'Укажите серию паспорта',
  NUMBER_PASSPORT_REQUIRED: 'Укажите номер паспорта',
  NON_EXISTENT_PASSPORT: 'Ошибка в серии паспорта',
  FULL_LENGTH_PASSPORT: 'Пожалуйста, укажите серию и номер полностью',
  FULL_LENGTH_PASSPORT_SERIES: 'Пожалуйста, укажите серию полностью',
  FULL_LENGTH_PASSPORT_NUMBER: 'Пожалуйста, укажите номер полностью',
  PASSPORT_DATE_REQUIRED: 'Укажите дату выдачи паспорта',
  PASSPORT_DATE_FULL: 'Укажите полную дату выдачи паспорта',
  DATE_NOT_FUTURE:
    'Проверьте дату. Дата не может быть позже сегодняшней',
  PASSPORT_DATE_OVERDUE: 'Паспорт просрочен',
  DATE_NOT_EXIST: 'Такой даты не существует',
  DATE_BEFORE_FOURTEEN: 'Проверьте дату. Паспорт не может быть выдан до 14 лет',
  OCCUPATION_WORK_PLACE: 'Укажите название организации, в которой вы работаете',
  OCCUPATION_WORK_PHONE: 'Укажите рабочий номер',
  PASSPORT_CODE_REQUIRED: 'Укажите код подразделения, выдавшего паспорт',
  PASSPORT_BP_REQUIRED: 'Укажите место вашего рождения',
  PASSPORT_BP_PATTERN:
    'Допускается ввод русских букв, пробела, цифр и знаков . , - —',
  PASSPORT_ADRESS_PATTERN:
    'Допускается ввод русских букв, пробела, цифр и знаков . , - —',
  PASSPORT_ADRESS_REQUIRED: 'Укажите ваш адрес по прописке',
  SNILS_LENGTH:
    'Номер СНИЛС должен состоять из 11 цифр, пример: 123-456-789-12',
  SNILS_CONTROL:
    'Номер не прошёл проверку. Укажите корректный номер СНИЛС или оставьте поле пустым',
  CONFIRMATION:
    'К сожалению, без данного подтверждения мы не сможем выдать вам заём',
  SECRET_PHRASE:
    'Кодовое слово должно содержать только русские буквы, до 10 символов. Примеры возможных слов: мама, солнышко, победа',
  PASSWORD_REQUIRED: 'Пароль вам понадобится для входа в личный кабинет',
  PASSWORD_LENGTH: 'Пароль должен содержать не менее 6 и не более 30 символов',
  PASSWORD_SYMBOL: 'Добавьте спец. знаки или заглавные буквы',
  PASSWORD_SECURE: 'Пароль достаточно надежен',
  PASSWORD_PATTERN: 'Пароль не соответствует требованиям.',
  WRONG_CONFIRMATION_CODE: 'Неверный код',
  WRONG_CONFIRMATION_CODE_LENGTH: 'Не хватает пары цифр',
  CITY_REQUIRED: 'Укажите город',
  STREET_REQUIRED: 'Укажите улицу',
  BUILDING_REQUIRED: 'Укажите здание',
  CALC_CONTROL_SUMM_SNILS:
    'Номер не прошёл проверку. Укажите корректный номер СНИЛС или оставьте поле пустым.',
  ERROR_SERIES: 'Ошибка в серии паспорта',
  CITY_PATTERN: 'Введите корректный город',
  STREET_PATTERN: 'Введите корректную улицу',
  WRONG_CODE: 'Неверный код',
  YANDEX_REQUIRED: 'Поле обязательно для заполнения',
  YANDEX_WALLET_ERROR:
    'Такого кошелька не существует. Пожалуйста, уточните номер',
  BIC_LENGTH: 'БИК должен состоять из 9 цифр',
  ACCOUNT_LENGTH: 'Номер счёта должен состоять из 20 цифр',
  BIC_FORMAT: 'БИК не соответствует формату. Похоже, где-то допущена ошибка',
  SETTLMENT_ACCOUNT_FORMAT:
    'Номер счёта не соответствует формату. Похоже, где-то допущена ошибка',
  EMAIL_DUPLICATE: 'Этот адрес электронной почты указан другим пользователем',
  STREET_HOME_REQUIRED:
    'Пожалуйста, введите полный адрес через запятую (улица, дом, квартира, если есть)',
  REGION_FORMAT:
    'Проверьте правильность написания области, края или республики',
  CITY_FORMAT:
    'Пожалуйста, проверьте правильность написания города или населённого пункта',
  BANK_NAME: 'Банк не найден',
  NOT_FULL_BIRTHDATE: 'Укажите полную дату рождения.',
  NOT_FULL_PASSPORT_DATE: 'Укажите полную дату выдачи.',
  RECOVERY_CODE_LENGTH: 'Введите проверочный код полностью.',
  RECOVERY_CODE: 'Введен неверный проверочный код',
  INVALID_DATE: 'Введите полную дату',
  INVALID_AMOUNT: 'Пожалуйста, укажите числовое значение',
  BIRTHPLACE_LENGTH: 'Минимальное количество символов 5',
  BIRTHPLACE_WORD_BAN: 'Место рождения содержит в себе только наименование населенного пункта, района (при наличии) и области (республики, края)',
};
